import { PatientDetailContent } from '@/features/patients/components/PatientDetailContent'
import { useGetPatientItems } from '@/features/patients/hooks/usePatient'
import { Activity } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ScanPatientContent({ patientId }: { patientId: string }) {
  const { t } = useTranslation()
  const { data: patientItems, isLoading: isLoadingPatientItems } = useGetPatientItems(patientId!, !!patientId)

  if (isLoadingPatientItems) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
        <p className="mt-1 text-sm text-muted-foreground">{t('common.loading')}</p>
      </div>
    )
  }

  if (!patientItems) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[80vh]">
        <Activity className="size-12 text-muted-foreground/30" />
        <h1 className="mt-4 text-lg font-semibold text-foreground">{t('patient.detail.notFoundBed')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('patient.detail.notFoundBed')} ID: {patientId}
        </p>
        <a href="/" className="mt-4 text-sm text-primary hover:underline">
          {t('common.backToHome')}
        </a>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-lg p-4">
      <PatientDetailContent patientItems={patientItems}></PatientDetailContent>
    </div>
  )
}
